export const CUSTOM_MAP_STYLE: google.maps.MapTypeStyle[] = [
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#C1D1EA' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#4576E5' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#E9F0FC' }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
]
